import React, { useState, useEffect, useRef } from "react";
import { navLinks, siteData } from "../data/mock";
import { Menu, X, Instagram } from "lucide-react";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const mobileNavRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#ffffff]/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[87.5rem] mx-auto px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="/"
          className="flex items-center p-0 no-underline"
        >
          <img
            src="/BTL-colour.svg"
            alt="Built to Lead"
            className="h-10 w-auto"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className="text-[#1f2937] bg-transparent border-none text-sm font-normal px-5 py-3 cursor-pointer transition-colors duration-300 hover:text-[#FE3A80] uppercase tracking-wider"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA + Instagram */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://instagram.com/builttoleadottawa"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-9 h-9 rounded-full border border-[#E1306C] text-[#E1306C] transition-all duration-300 hover:bg-[#E1306C] hover:text-white"
            aria-label="Instagram"
          >
            <Instagram size={16} />
          </a>
          <a
            href="/gallery"
            className="inline-flex items-center justify-center bg-[#FE3A80] text-[#ffffff] border-none rounded-[10rem] px-6 py-3 text-sm font-semibold uppercase tracking-tight cursor-pointer transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] no-underline"
            style={{ fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "-0.04em" }}
          >
            View Gallery
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden bg-transparent border-none text-[#1f2937] cursor-pointer p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav */}
      <div
        ref={mobileNavRef}
        className="md:hidden bg-[#ffffff]/98 backdrop-blur-md border-t border-[#e5e7eb] overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: mobileOpen ? mobileNavRef.current?.scrollHeight + "px" : "0px",
          opacity: mobileOpen ? 1 : 0,
          borderTopWidth: mobileOpen ? "1px" : "0px",
        }}
      >
        <div className="px-6 pb-6">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left text-[#1f2937] bg-transparent border-none text-base font-normal py-4 cursor-pointer uppercase tracking-wider border-b border-[#e5e7eb]"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {link.label}
            </button>
          ))}
          <a
            href="/gallery"
            className="block w-full mt-4 bg-[#FE3A80] text-[#ffffff] border-none rounded-[10rem] px-6 py-4 text-sm font-semibold uppercase tracking-tight cursor-pointer text-center no-underline"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            View Gallery
          </a>
          <a
            href="https://instagram.com/builttoleadottawa"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full mt-3 py-3 text-[#E1306C] text-sm font-medium uppercase tracking-wider no-underline"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            <Instagram size={16} />
            Follow Us
          </a>
        </div>
      </div>
    </header>
  );
};
